
import { Placement } from '@post-office/placements-frontend/rovo-ops-group-detail-spotlight';
export default Placement;
